import { render, staticRenderFns } from "./Accordion.video.vue?vue&type=template&id=3cbb96b3&scoped=true&lang=pug&"
import script from "./Accordion.video.vue?vue&type=script&lang=ts&"
export * from "./Accordion.video.vue?vue&type=script&lang=ts&"
import style0 from "./Accordion.video.vue?vue&type=style&index=0&id=3cbb96b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbb96b3",
  null
  
)

export default component.exports